import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/system";
import { FileText } from "lucide-react";

const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} arrow placement="top" />
))({
    "& .MuiTooltip-tooltip": {
        backgroundColor: "#ffffff",
        color: "#0f172a",
        borderRadius: "0.9rem",
        boxShadow: "0 18px 38px rgba(15, 23, 42, 0.18)",
        padding: 0,
        maxWidth: "20rem",
        minWidth: "13rem",
        overflow: "hidden"
    },
    "& .MuiTooltip-arrow": {
        color: "#ffffff"
    }
});

function NoteTooltip({ note, noteColor, children }) {
    const headerColor = noteColor || "#f59e0b";

    return (
        <StyledTooltip
            title={
                <div className="oct-note-tooltip">
                    <div className="oct-note-tooltip__header" style={{ backgroundColor: headerColor }}>
                        <FileText size={16} strokeWidth={2.2} />
                        <span>Note</span>
                    </div>
                    <div className="oct-note-tooltip__body">
                        {note}
                    </div>
                </div>
            }
        >
            {children}
        </StyledTooltip>
    );
}

export default NoteTooltip;
